import { TableOption, TableSource } from '@tripointe/tripointe-cms/types';

import { TOOLTIPS_TEXTS } from './tooltips';

const homeDocumentsTableTooltips = TOOLTIPS_TEXTS.homeDocumentsTable;

export const BASE_HOME_DOCUMENTS_ACTIVE_OPTIONS: TableOption[] = [
  { action: 'mobileMenu', src: 'icons/more' }
];

export const BASE_HOME_DOCUMENTS_ARCHIVED_OPTIONS: TableOption[] = [
  { action: 'unarchive', src: 'icons/unarchive' },
  { action: 'deleteArchive', src: 'icons/delete' },
  { action: 'mobileMenu', src: 'icons/more' }
];

export const BASE_HOME_DOCUMENTS_TABLE_CONFIG: TableSource = {
  displayedColumns: ['name', 'description', 'fileSize', 'phases', 'options'],
  displayedTitles: ['Name', 'Description', 'File Size', 'Phase(s)', 'Actions'],
  columnsConfig: [
    { sorting: true },
    { sorting: true },
    { sorting: true },
    { sorting: false },
    { sorting: false }
  ],
  displayedTooltips: [
    homeDocumentsTableTooltips.name,
    homeDocumentsTableTooltips.description,
    homeDocumentsTableTooltips.fileSize,
    homeDocumentsTableTooltips.phases
  ],
  options: null,
  dataSource: []
};
